import type { FaireProductEntity } from "../../entity_types/product";

export const p_e4rfyfzahq: FaireProductEntity = {
  token: "p_e4rfyfzahq",
  type: "product",
  name: "I ❤️ Cruises Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c9e9dfa6f3c9f0b6d55c6ea5db373f66449f2f00b44f372720b3ecd72c8e523a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cc98111d45308d1e240ccd43617b134aaee952f6999e55cd18f524638d5f505.jpeg",
    "https://cdn.faire.com/fastly/20b2f6aad968550f58f5523005ce4f3b23592c4479ef3a9f45b7d1dac9c9e389.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/31ba95c69e2a2ec086a7a3466fc56af0c4b9e6f7254f5a06893bb8b38678d0a8.jpeg",
    "https://cdn.faire.com/fastly/034f504fc8c68a2fdac53f738823bb20486ed5bc241b2a206bf53cbb6189fe66.jpeg"
  ],
  priceDollars: 3.38,
  description: "What? You DON'T like circular windows and coming back to a towel swan on your bed? Pshh get real. These socks are as life-affirming as an all-you-can-eat buffet and the smell of sunscreen in the morning. All aboard!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:33.495Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
